import { NgxsConfig } from '@ngxs/store/src/symbols';
import { environment } from '../../environments/environment';

export const NGXS_CONFIG: Partial<NgxsConfig> = {
  developmentMode: !environment.production,
  selectorOptions: {
    suppressErrors: false,
    injectContainerState: false,
  },
};
